import '../styles/MobileBar.css';

const MobileBar = () => {


  return (
    <div className="mobile" >
      <div className="mobile-logo">
        <img src="/images/e.png" alt="Mobile Logo" className="logo-image" />
      </div>
      <span style={{padding:"0 5px", fontSize:"14px"}}>
        admin
      </span>
    </div>
  );
};

export default MobileBar;
